(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pd-home-course-card"] && !Shopify.designMode) return;
  try {
    // Custom script to render date as a range if both first_date and second_date are present
      document.addEventListener('DOMContentLoaded', function () {
        const dateElements = document.querySelectorAll('[data-firstdate][data-seconddate]');
        dateElements.forEach(function (el) {
          const firstDate = el.getAttribute('data-firstdate');
          const secondDate = el.getAttribute('data-seconddate');
          if (firstDate && secondDate) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            const firstDateObj = new Date(firstDate);
            const secondDateObj = new Date(secondDate);

            if (!isNaN(firstDateObj) && !isNaN(secondDateObj)) {
              const formatter = new Intl.DateTimeFormat('es-MX', options);
              el.textContent = `${formatter.formatRange(firstDateObj, secondDateObj)}`;
            }
          }
        });
      });
  } catch(e) { console.error(e); }
})();

})();
